import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import GroupsTable from "./GroupsTable";
import SelectedGroup from "./SelectedGroup";

const Groups = (props) => {
  const [groups, setGroups] = useState(props.groups);
  const [selectedGroup, setSelectedGroup] = useState(props.groups[0]);

  useEffect(() => {
    if (!selectedGroup) return;

    setSelectedGroup(groups.find((group) => group.id === selectedGroup.id));
  }, [groups]);

  return (
    <div className="flex flex-start gap-24">
      <GroupsTable
        groups={groups}
        setGroups={setGroups}
        selectedGroup={selectedGroup}
        setSelectedGroup={setSelectedGroup}
      />

      <SelectedGroup
        groups={groups}
        setGroups={setGroups}
        selectedGroup={selectedGroup}
        allCourses={props.allCourses}
        allUsers={props.allUsers}
      />
    </div>
  );
};

Groups.propTypes = {
  groups: PropTypes.array,
  allCourses: PropTypes.array,
  allUsers: PropTypes.array,
};

export default Groups;
